import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { stringify } from "qs";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { Configuration, ConfigurationApi, } from "@plansoft-configuration-renderer/configuration-api";
/**
 * Helper component for managing OAuth2 authentication in development
 * @param props
 * @returns
 */
export function OAuthManager(props) {
    const { basePath, isLocalDevelopment } = props;
    const [ok, setOk] = useState(true);
    const [status, setStatus] = useState(0);
    const [statusText, setStatusText] = useState("");
    useEffect(() => {
        console.log({ isLocalDevelopment });
        if (!isLocalDevelopment) {
            return;
        }
        const apiConfig = new Configuration({ basePath });
        const api = new ConfigurationApi(apiConfig);
        // compose return path
        const returnUrl = window.location.toString();
        const oAuthUrl = "/oauth2/start?" + stringify({ returnUrl });
        function handleResponseError(response) {
            setOk(response.ok);
            setStatus(response.status);
            setStatusText(response.statusText);
            if (response.status === 401) {
                window.location.replace(oAuthUrl);
            }
        }
        api
            .getInfo()
            .then((res) => {
            console.log("Configurator Info", basePath, res);
        })
            .catch((err) => {
            if (err instanceof Response) {
                handleResponseError(err);
            }
            if (err && err.response instanceof Response) {
                handleResponseError(err.response);
            }
        });
    }, [basePath, isLocalDevelopment]);
    const alert = !ok ? (_jsxs(Alert, { severity: "error", children: [_jsx(AlertTitle, { children: "OAuthGuard" }), "HTTP Status ", status, " ", statusText] })) : null;
    return _jsx(_Fragment, { children: alert });
}
//# sourceMappingURL=OAuthManager.js.map